import * as React from 'react';
import FormField, { BaseFormFieldProps } from './FormField';
import RTEInput from '../input/basicInputs/RTEInput';

// @observer
class RTEFormField extends React.Component<BaseFormFieldProps> {
  render() {
    return <FormField {...this.props}>{({ input }) => <RTEInput {...input} />}</FormField>;
  }
}

export default RTEFormField;
